/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Audio {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { graphql } from "gatsby"
import { Section } from "@bw/bits"
import { Audio as AudioModule } from "@bw/modules"

const Audio = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  idAttribute,
  classAttribute,
  backgroundVariant,
  isFollowedByModuleWithBackgroundVariant,
  file,
}) => {
  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        button,
        buttonPosition,
        idAttribute,
        classAttribute,
        backgroundVariant,
        isFollowedByModuleWithBackgroundVariant,
      }}
      containerSize="small"
    >
      <AudioModule url={file.url} />
    </Section>
  )
}

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ...AudioModuleFragment
 *
 * This is also what you will get in the props of your Audio
 * resolver component.
 */
export const query = graphql`
  fragment AudioModuleFragment on AudioModule {
    file {
      url
    }
  }
`

export { Audio }
